import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceManagementService, DevicesFamily } from 'src/app/device/device-management.service';
import { EnterpriseService } from 'src/app/enterprise/enterprise.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { UsersService } from 'src/app/users/users.service';
import { SitesService } from 'src/app/sites/sites.service';
import * as _ from 'underscore';
import { OrdersService } from '../orders/orders.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { AttachmentsService } from 'src/app/shared/attachments/attachments.service';
import { Subscription } from 'rxjs';
import { ColumnsConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceFactory } from 'src/app/home/site-dashboard/device/device-factory/device-factory';
import { DeviceTypeService } from 'src/app/home/site-dashboard/device/device-type.service';
import { NocConfigurationService } from 'src/app/noc-tools/noc-configurations/noc-configuration.service';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import { DeviceService } from 'src/app/home/site-dashboard/device/device.service';

interface FwCheckDevice {
	serial_number: string;
	fw_version?: number | string | null;
}

@Component({
	selector: 'app-shipping-out',
	templateUrl: './shipping-out.component.html'
})
export class ShippingOutComponent implements OnInit, AfterViewInit {

	readonly DevicesFamily = DevicesFamily;
	selectedDeviceFamily = DevicesFamily.TELEMETRICS; 

	currentUser: any = [];
	searchString: string = '';
	searchBy: string = 'mac'; // sn: serial number, mac: mac address
	searchResult: any = null;
	sites: any = [];
	customerEnterprises = <any>[];

	readonly originalEnterpriseGroups: any[] = [
		'dealer',
		'customer',
		'battery_oem',
	];

	enterpriseGroups: any[] = [...this.originalEnterpriseGroups];

	selectedDevices: any = [];
	selectedDeviceTypes = this.createEmptyDeviceTypesMap();
	selectedGroup: any;
	selectedEnterpriseList: any;

	selectedCustomerList: any;
	selectedEnterpriseSitesList: any;
	selectedSiteList: any;

	shipOutToEnterprise: number;
	shipOutToCustomer: number;
	shipOutToSite: number;
	smartRebatesGroup: boolean = false;
	cblGroup: boolean = false;
	site: any = {};
	newSite = {id: 0, name: this.translateService.instant('site.new_site')};

	po_number: string;
	purchaseOrderMaxLength: 20;
	poNumbersDropdown: string[] = [];
	allPoNumbers: any = {};
	motiveEnergyData: any;
	cblCustomerData: any;
	smartRebatesSelectedErr = "";
	disableSmartRebateOption: boolean = false;
	showUploadFileEle = true;
	searchBulk = false;
	maxDevicesCountPerFile = 50;
	multiSearchDeviceSubscription!: Subscription;
	bulkSearchNotFoundDevices: string[] = [];
	usePowerStudyDevicesSite: boolean = false;

	@ViewChild('selectedFilesDialog') selectedFilesDialog: ModalComponent;
	selectedFiles: any = [];
	readonly maxFilesCount: number = 5;
	readonly mbBytes: number = 1048576; // 1 MB in bytes
	readonly maxSize: number = 10 * this.mbBytes;
	readonly allowedUploadFilesExt: string[] = this.attachmentsService.allowedUploadFilesExt;

	@ViewChild('labelImport')
	labelImport: ElementRef;

	columns:ColumnsConfig[] = [
		{key: 'file_name', name: this.translateService.instant('ready_to_ship.file_name'), type: 'string'},
		{key: 'action', name: this.translateService.instant('g.action'), type: 'icon'}
	];

	shipmentEnterprises: any = [];

	// --- SCT Managed Shipping Out properties ---
	@ViewChild('deviceConfigModal') deviceConfigModal: ModalComponent;
	skipWarningsChecks: boolean = false;
	availableTokens: any = {};
	availableTokensList: any[] = [];
	usedTokens: any = {};

	// Currently editing device config
	selectedDeviceMacAddress: string = '';
	deviceConfigData: any = {};

	// Device config form options (from CommonDataService)
	feederMeterOptions = this.commonDataService.feederMeterOptions;
	defaultFeederMeter: number = 1;

	accumulatingSubtractingOptions = this.commonDataService.accumulatingOptions;
	defaultAccumulatingSubtracting: number = 0;

	nominalVoltageOptions = this.commonDataService.nominalVoltageOptions;
	ctRatioOptions = [...this.commonDataService.ctRatioOptions, ...this.commonDataService.ctRatioRogowskiType];
	wiringModeOptions = this.commonDataService.wiringModeOptions;
	readonly defaultWiringMode: number = 3;
	readonly wiringModeNominalText: any = { 0: 'L-L', 1: 'L-L', 2: 'L-L', 3: 'L-N' };

	readonly maxMeterNumber: number = 32767;

	shippingOutRequiredFields = ['power_view_sn', 'is_feeder_meter', 'is_meter_subtracting', 'nominal_voltage', 'ct_ratio', 'wiring_mode', 'meter_number', 'empty_nbiot_bands'];

	readonly deviceValidationRangeValues = {
		voltage: { min: 475, max: 485 },
		current: { min: 19, max: 21 },
		power_factor: { min: 0.9 },
	};

	constructor(
		private router: Router,
		private chRef: ChangeDetectorRef,
		private translateService: TranslateService,
		public usersService: UsersService,
		private sideMenuService: SideMenuService,
		private notificationMessage: NotificationMessageService,
		private deviceManagementService: DeviceManagementService,
		public enterpriseService: EnterpriseService,
		public sitesService: SitesService,
		public ordersService: OrdersService,
		public attachmentsService: AttachmentsService,
		private commonService: CommonService,
		private el: ElementRef,
		private renderer: Renderer2,
		private deviceTypeService: DeviceTypeService,
		private nocConfigService: NocConfigurationService,
		private commonDataService: CommonDataService,
		private deviceService: DeviceService,
	) { }

	ngAfterViewInit() {
		this.deviceConfigModal.onClose.subscribe((result) => {
			if (result) {
				this.saveDeviceConfig();
			}
		});
	}

	private createEmptyDeviceTypesMap() {
		return {
			[DeviceFactory.typesString.iotah]: [],
			[DeviceFactory.typesString.charglink]: [],
			[DeviceFactory.typesString.study]: [],
			[DeviceFactory.typesString.battlink]: [],
			[DeviceFactory.typesString.lithiumBattlink]: [],
			[DeviceFactory.typesString.battlinkII]: [],
			[DeviceFactory.typesString.brm]: [],
			[DeviceFactory.typesString.ioTEmeterSp1]: [],
			[DeviceFactory.typesString.ioTEmeterSp3]: [],
			[DeviceFactory.typesString.ioTEmeter]: [],
			[DeviceFactory.typesString.ioTEmeterEdge]: [],
		};
	}

	ngOnInit() {
		this.currentUser = this.usersService.getCurrentUser();
		if(!this.usersService.hasAccessFunction('shipment_management'))
			this.router.navigate(['unauthorized']);

		this.sideMenuService.hide();
		this.site.installation_date = new Date(new Date().setHours(0, 0, 0, 0));
		this.getOrderPoNumbers();
		this.checkSmartRebatesShippingOption();
		this.getShipmentEnterprises();
		this.getAvailableTokens();
	}

	getShipmentEnterprises () {
		this.enterpriseService.getEnterprises({ source: 'shipment', deviceFamily: this.selectedDeviceFamily }).subscribe((enterpriseData: any[]) => {
			this.shipmentEnterprises = enterpriseData;
		});
	}

	// Maps device type string to the backend remaining count field
	private readonly typeToRemainingFieldMap = {
		[DeviceFactory.typesString.iotah]: 'remaining_iotah_count',
		[DeviceFactory.typesString.charglink]: 'remaining_charglink_count',
		[DeviceFactory.typesString.study]: 'remaining_study_count',
		[DeviceFactory.typesString.battlink]: 'remaining_battlink_count',
		[DeviceFactory.typesString.lithiumBattlink]: 'remaining_battlink_lithium_count',
		[DeviceFactory.typesString.battlinkII]: 'remaining_battlink_ii_count',
		[DeviceFactory.typesString.brm]: 'remaining_brm_count',
		[DeviceFactory.typesString.ioTEmeterSp1]: 'remaining_sp1_count',
		[DeviceFactory.typesString.ioTEmeterSp3]: 'remaining_sp3_count',
		[DeviceFactory.typesString.ioTEmeter]: 'remaining_iotemeter_count',
		[DeviceFactory.typesString.ioTEmeterEdge]: 'remaining_iotemeter_edge_count',
	};

	// Maps remaining count field to its display label key
	private readonly remainingFieldToLabelMap = {
		'remaining_iotah_count': () => this.translateService.instant('g.iotah'),
		'remaining_charglink_count': () => this.translateService.instant('g.charglink'),
		'remaining_study_count': () => this.translateService.instant('studies.power_studies'),
		'remaining_battlink_count': () => this.translateService.instant('g.battlink'),
		'remaining_battlink_lithium_count': () => this.translateService.instant('g.battlink_lithium'),
		'remaining_battlink_ii_count': () => this.translateService.instant('g.battlink_ii'),
		'remaining_brm_count': () => this.translateService.instant('g.brm'),
		'remaining_sp1_count': () => DeviceFactory.typesString.ioTEmeterSp1,
		'remaining_sp3_count': () => DeviceFactory.typesString.ioTEmeterSp3,
		'remaining_iotemeter_count': () => DeviceFactory.typesString.ioTEmeter,
		'remaining_iotemeter_edge_count': () => DeviceFactory.typesString.ioTEmeterEdge,
	};

	getOrderPoNumbers() {
		this.ordersService.getOrderPoNumbers().subscribe((data: any) => {
			const orders: any = {};
			for (const order of data) {
				orders[order.po_number] = order;
			}
			this.allPoNumbers = orders;
			this.updatePoNumbersDropdown();
		});
	}

	updatePoNumbersDropdown() {
		const list: any = [];

		// Count selected devices per remaining field for the current PO
		const selectedCounts: any = {};
		for (const deviceType of Object.keys(this.selectedDeviceTypes)) {
			const field = this.typeToRemainingFieldMap[deviceType];
			if (field) {
				selectedCounts[field] = (selectedCounts[field] || 0) + this.selectedDeviceTypes[deviceType].length;
			}
		}

		for (const poNumber of Object.keys(this.allPoNumbers)) {
			const order = this.allPoNumbers[poNumber];
			const isCurrentPo = poNumber === this.po_number;

			const deviceList = Object.entries(this.remainingFieldToLabelMap).map(([field, labelFn]) => {
				let count = order[field] || 0;
				// Deduct selected devices only for the currently selected PO
				if (isCurrentPo && selectedCounts[field]) {
					count = Math.max(0, count - selectedCounts[field]);
				}
				return count ? `${count} ${labelFn()}` : null;
			}).filter(Boolean);

			// Keep the currently selected PO in the dropdown even if remaining is 0
			if (!deviceList.length && !isCurrentPo)
				continue;

			const result = deviceList.length > 1
				? deviceList.slice(0, -1).join(', ') + ` ${this.translateService.instant('g.and')} ` + deviceList.slice(-1)
				: (deviceList[0] || '0');

			list.push({
				value: poNumber,
				label: `${poNumber} (${this.translateService.instant('orders.remaining', { remainingDevicesCount: result })})`
			});
		}
		this.poNumbersDropdown = this.commonService.sortDataAlphabetically(list, 'value');

		// Force ng-select to pick up the updated label for the selected item
		// if (this.po_number) {
		// 	const currentPo = this.po_number;
		// 	this.po_number = null;
		// 	setTimeout(() => {
		// 		this.po_number = currentPo;
		// 		this.chRef.detectChanges();
		// 	});
		// }
	}

	getDevices() {
		this.notificationMessage.closeNotification();
		this.deviceManagementService.searchDevices(this.searchString, this.searchBy, false, false, 'shipping-out', false, this.selectedDeviceFamily).subscribe((data: any) => {
			this.searchResult = data.devices || [];
			this.sites = _.indexBy(data.sites || [], 'id');

			if (this.searchResult.length > 0 && _.findWhere(this.selectedDevices, {mac_address: this.searchResult[0].mac_address}))
				this.searchResult = [];

			this.bulkSearchNotFoundDevices = [];
		});
	}

	checkOrderDevicesAvailability(device: any) {
		let errorMsg = '';

		const deviceType = this.getDeviceTypeString(device);

		if (this.selectedDeviceTypes[deviceType].length >= this.getOrderAvailableDevices(this.po_number, deviceType)) {
			if (deviceType == 'Brm')
				errorMsg = this.translateService.instant('orders.reached_order_bmr_limit');
			else
				errorMsg = this.translateService.instant('orders.reached_order_limit', { deviceType });
		}

		return errorMsg;
	}

	prepareForShipment(device, customerId) {
		if (this.isIotemeterEdgeDevice(device) && !device.connected)
			return this.notificationMessage.setMessage(this.translateService.instant('ready_to_ship.device_disconnected'), { clearOnXTimeNavigate: 1 });

		const orderAvailabilityErrorMsg = this.checkOrderDevicesAvailability(device);
		if (orderAvailabilityErrorMsg)
			return this.notificationMessage.setMessage(orderAvailabilityErrorMsg, { clearOnXTimeNavigate: 1 });

		if (this.isIotemeterEdgeDevice(device)) {
			// If skip checkbox is selected, bypass voltage/current/PF/CT checks
			if (this.skipWarningsChecks)
				return this.addDeviceToShipment(device, customerId);

			this.deviceManagementService.getLiveQuickView(device.mac_address, { includeImDevices: true }).subscribe((res: any) => {
				const qv = this.commonService.decompress(res, 'quick_view');

				// Connectivity check — always enforced regardless of skip checkbox
				if (!qv?.live_rt) {
					return this.notificationMessage.setMessage(this.translateService.instant('ready_to_ship.device_disconnected'), { clearOnXTimeNavigate: 1 });
				}

				// Validate voltage, current, power factor, and CT reversed warnings — collect ALL failures
				const messages: string[] = [];

				const voltage = [qv.live_rt.voltage_a_ll, qv.live_rt.voltage_b_ll, qv.live_rt.voltage_c_ll];
				const current = [qv.live_rt.current_a, qv.live_rt.current_b, qv.live_rt.current_c];
				const powerFactor = [qv.live_rt.pf_a, qv.live_rt.pf_b, qv.live_rt.pf_c];

				// 1. Voltage check
				for (const value of voltage) {
					if (value < this.deviceValidationRangeValues.voltage.min || value > this.deviceValidationRangeValues.voltage.max) {
						messages.push(this.translateService.instant('ready_to_ship.voltage_out_of_range'));
						break;
					}
				}

				if (messages.length)
					return this.showValidationMessages(messages);

				// 2. Current check
				for (const value of current) {
					if (value < this.deviceValidationRangeValues.current.min || value > this.deviceValidationRangeValues.current.max) {
						messages.push(this.translateService.instant('ready_to_ship.current_out_of_range'));
						break;
					}
				}

				if (messages.length)
					return this.showValidationMessages(messages);

				// 3. Power factor check
				for (const value of powerFactor) {
					if (value < this.deviceValidationRangeValues.power_factor.min) {
						messages.push(this.translateService.instant('ready_to_ship.power_factor_out_of_range'));
						break;
					}
				}

				if (messages.length)
					return this.showValidationMessages(messages);

				// 4. CT reversed warnings check
				const ctWarningFields = [
					'phase_a_ct_reversed', 'phase_b_ct_reversed', 'phase_c_ct_reversed',
					'current_a_reversed_warning', 'current_b_reversed_warning', 'current_c_reversed_warning'
				];
				const ctWarnings: string[] = [];
				for (const field of ctWarningFields) {
					if (qv.live_rt[field]) {
						ctWarnings.push(this.translateService.instant('warnings.' + field));
					}
				}
				if (ctWarnings.length) {
					messages.push(this.translateService.instant('ready_to_ship.warnings_errors', { warnings: '<br>' + ctWarnings.join('<br>') }));
				}

				if (messages.length)
					return this.showValidationMessages(messages);

				this.addDeviceToShipment(device, customerId);
			});
			return;
		}

		this.addDeviceToShipment(device, customerId);
	}

	showValidationMessages(messages: string[]) {
		return this.notificationMessage.setMessage('shipping-out-im-validation', {
			message: messages.join('<br>'),
			safeType: 'html',
			clearOnXTimeNavigate: 1,
		});
	}

	private addDeviceToShipment(device, customerId) {
		device._customer_id = customerId;
		this.selectedDevices.push(device);

		const deviceType = this.getDeviceTypeString(device);
		if (this.selectedDeviceTypes[deviceType]) {
			this.selectedDeviceTypes[deviceType].push(device);
		}

		this.updatePoNumbersDropdown();

		this.searchString = '';
		this.searchResult = this.searchResult.filter((item: { mac_address: any; }) => item.mac_address != device.mac_address);
		if (this.shipOutToCustomer && this.isAllDevicesPowerStudies())
			return this.handlePowerStudyDevicesSite();

		if (this.usePowerStudyDevicesSite || (this.shipOutToCustomer && this.isIotemeterDevice(device)))
			return this.handleShippedDevicesSite();
	}

	removeFromShipment(device: any) {
		const macAddress = device.mac_address;
		const wasIotemeter = this.isIotemeterDevice(device);
		this.selectedDevices = this.selectedDevices.filter((device) => {
			return device.mac_address != macAddress;
		});

		const deviceType = this.getDeviceTypeString(device);
		if (this.selectedDeviceTypes[deviceType]) {
			this.selectedDeviceTypes[deviceType] = this.selectedDeviceTypes[deviceType].filter((device) => {
				return device.mac_address != macAddress;
			});
		}

		this.updatePoNumbersDropdown();

		if (this.shipOutToCustomer && this.isAllDevicesPowerStudies())
			return this.handlePowerStudyDevicesSite();

		// Refresh site list if iotemeter presence changed or was power study site
		if (this.usePowerStudyDevicesSite || (this.shipOutToCustomer && wasIotemeter))
			return this.handleShippedDevicesSite();
	}

	shipOutDevices() {
		if(this.selectedDevices.length == 0 || !this.po_number) return;

		const validation: any = this.filesValidation();
		if (Object.keys(validation).length) {
			let message = [];

			if (validation.max_count)
				return this.notificationMessage.setMessage(this.translateService.instant('ready_to_ship.files_max_count_err', { max_files_count: this.maxFilesCount }), {clearOnXTimeNavigate: 1});

			if (validation.extension)
				message.push(`${this.translateService.instant('ready_to_ship.extension_err')}: ${this.allowedUploadFilesExt.join(', ')}`);
			if (validation.size)
				message.push(this.translateService.instant('ready_to_ship.size_err', { max_size: this.maxSize / this.mbBytes }));

			return this.notificationMessage.setMessage(message.join(this.translateService.instant('g.and')), {clearOnXTimeNavigate: 1});
		}

		// ST-2774: Consumer BATTlink / BATTcom needs firmware that supports BATTcom (the backend checks it too)
		if (this.cblGroup) {
			const lowFwDevices = this.getBelowBattcomFwDevices(this.selectedDevices);
			if (lowFwDevices.length)
				return this.notificationMessage.setMessage(this.getCblMinFwErrorMessage(lowFwDevices), {clearOnXTimeNavigate: 1});
		}

		let deviceIds = _.pluck(this.selectedDevices, 'mac_address');

		let isNewSite = false;

		let options: any = {};
		if(this.shipOutToCustomer && (this.shipOutToSite || this.shipOutToSite === 0)) {
			options.siteInfo = {customer_id: this.shipOutToCustomer};
			if(this.shipOutToSite)
				options.siteInfo.site_id = this.shipOutToSite;
			else {
				// New Site
				let site = Object.assign({}, this.site);
				let insDate = new Date(site.installation_date);
				site.installation_date = Math.floor((-insDate.getTimezoneOffset() * 60000 + insDate.getTime()) / 1000);
				options.siteInfo.newSite = site;
				isNewSite = true;
			}
		}

		options.po_number = this.po_number;
		options.devices_family = this.selectedDeviceFamily;

		// SCT Managed: validate device configs and include shipping data for Edge devices only.
		if (this.hasIotemeterEdgeDevices()) {
			if (this.checkShippingOutDevicesData().length)
				return;

			const devicesShippingData = {};
			for (const device of this.selectedDevices) {
				if (this.isIotemeterEdgeDevice(device)) {
					devicesShippingData[device.mac_address] = {
						token: device.token,
						token_id: device.token_id,
						meter_number: device.meter_number,
						power_view_sn: device.power_view_sn,
						is_feeder_meter: device.is_feeder_meter,
						is_meter_subtracting: device.is_meter_subtracting,
						ct_ratio: device.ct_ratio,
						wiring_mode: device.wiring_mode,
						empty_nbiot_bands: device.empty_nbiot_bands,
						nominal_voltage: device.nominal_voltage,
					};
				}
			}
			options.devicesShippingData = devicesShippingData;
			options.sctManaged = true;
			options.skip_warnings_checks = this.skipWarningsChecks;
			options.zoneDiff = new Date().getTimezoneOffset() * -1;
		}

		const formData = new FormData();
		for (const file of this.selectedFiles)
			formData.append("files", file.row);

		formData.append('devicesIds', JSON.stringify(deviceIds));
		formData.append('enterpriseId', JSON.stringify(this.shipOutToEnterprise));
		formData.append('options', JSON.stringify(options));

		this.deviceManagementService.shipOutDevices(formData).subscribe((data: any) => {
			if(data.api_status) {
				let message = 'globalErrMsg';
				switch (data.api_status) {
					case 2:
						message = 'translate|common.device_not_sct_inventory';
					break;
					case 3:
						message = 'translate|ready_to_ship.enterprise_no_inventory';
					break;
					case 4:
						message = 'translate|site.site_name_already_exist';
					break;
					case 5:
						message = 'translate|ready_to_ship.invalid_po_number';
					break;
					case 6:
						message = 'translate|orders.reached_order_count';
					break;
					case 7:
						message = 'translate|site.reserved_site_name';
						const form = this.el.nativeElement;
						const ele = form.querySelectorAll('[name=name]');
						if(ele && ele[0])
							this.renderer.addClass(ele[0], 'invalid-input');
					break;
					case 8:
						message = 'translate|ready_to_ship.disconnected_devices';
					break;
					case 9:
						message = 'translate|ready_to_ship.charglink_devices';
					break;
					case 10: {
						const disconnectedDevices = data.response || [];
						message = this.translateService.instant('ready_to_ship.disconnected_status_err') + ' : ' + disconnectedDevices.join(', ');
					break;
					}
					case 11: {
						const missingDataDevices = data.response || [];
						message = this.translateService.instant('ready_to_ship.missing_data_status_err') + ' : ' + missingDataDevices.join(', ');
					break;
					}
					case 12: {
						const invalidDevices = data.response || [];
						const errMessage = this.translateService.instant('ready_to_ship.invalid_meter_number_status_err');
						message = errMessage + ' : ' + invalidDevices.join(', ');
					break;
					}
					case 13:
						message = this.getCblMinFwErrorMessage(data.response || []);
					break;
				}
				return this.notificationMessage.setMessage(message, {clearOnXTimeNavigate: 1});
			}

			this.resetValues();
			this.getOrderPoNumbers();
			this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
			if(isNewSite)
				this.onGroupChanged();
		});
	}

	// Devices whose fw_version was removed by field permissions are left for the backend to decide
	getBelowBattcomFwDevices(devices: FwCheckDevice[]): FwCheckDevice[] {
		return devices
			.filter((device) => 'fw_version' in device && !this.deviceService.isFWSupportedFeature(+device.fw_version || 0, 'battcom'))
			.map((device) => ({ serial_number: device.serial_number, fw_version: +device.fw_version || null }));
	}

	getCblMinFwErrorMessage(devices: FwCheckDevice[]): string {
		const notAvailable = this.translateService.instant('g.n/a');
		const devicesText = devices.map((device) => `${device.serial_number} (${device.fw_version || notAvailable})`).join(', ');
		const minFwVersion = this.commonService.CBL_MIN_FW_VERSION.toFixed(5);
		const errMessage = this.translateService.instant('ready_to_ship.cbl_min_fw_version_err', { min_fw_version: minFwVersion });

		return `${errMessage} : ${devicesText}`;
	}

	resetValues() {
		this.selectedDevices = [];
		this.selectedFiles = [];
		this.po_number = null;
		this.searchString = '';
		this.searchResult = [];
		this.bulkSearchNotFoundDevices = [];
		this.showUploadFileEle = true;

		if (this.labelImport) {
			this.labelImport.nativeElement.value = '';
			this.labelImport.nativeElement.innerText = this.translateService.instant('shipment.import_devices_csv');
		}

		this.usedTokens = {};
		this.skipWarningsChecks = false;
		this.getAvailableTokens();
		this.selectedDeviceTypes = this.createEmptyDeviceTypesMap();
	}

	onGroupChanged() {
		if (this.selectedGroup != 'smart_rebates') {
			this.smartRebatesSelectedErr = '';
			this.smartRebatesGroup = false;
		}

		if (this.selectedGroup != 'cbl') {
			this.cblGroup = false;
		}

		let selectedGroup = [this.selectedGroup];
		if(this.selectedGroup == 'dealer')
			selectedGroup.push('service_dealer');

		this.clearSelections(3);

		const filters = { groupType: selectedGroup, source: 'shipment', deviceFamily: this.selectedDeviceFamily };
		if (this.selectedDeviceFamily == DevicesFamily.IOTEMETER)
			delete filters.groupType;

		this.enterpriseService.getEnterprises(filters).subscribe((res: any) => {
			this.selectedEnterpriseList = this.commonService.sortDataAlphabetically(res, 'name');
		});
	}

	handleSmartRebatesGroup() {
		this.smartRebatesGroup = true;
		this.cblGroup = false;
		this.motiveEnergyData = this.commonService.getMotiveEnergyCustomerData();
		this.selectedEnterpriseList = this.shipmentEnterprises;
		this.shipOutToEnterprise = this.motiveEnergyData.motiveEnergyEnterprise;

		this.onEnterpriseChanged();
	}

	handleCBLGroup() {
		this.cblGroup = true;
		this.smartRebatesGroup = false;
		this.cblCustomerData = this.commonService.getCBLCustomerData();
		this.selectedEnterpriseList = this.shipmentEnterprises;
		this.shipOutToEnterprise = this.cblCustomerData.enterprise_id;

		this.onEnterpriseChanged();
	}

	onEnterpriseChanged() {
		this.clearSelections(2);
		if (this.selectedDeviceFamily == DevicesFamily.TELEMETRICS) {
			this.sitesService.getEnterpriseSitesInfo(this.shipOutToEnterprise).subscribe((res: any) => {
				const sites = res.sites || [];
				if(sites.length) {
				this.selectedCustomerList = _.chain(sites).map(({customer_id, customer_name}) => ({id: customer_id, name: customer_name})).uniq((obj) => {return obj.id;}).value();
					this.selectedCustomerList = this.commonService.sortDataAlphabetically(this.selectedCustomerList, 'name');
					this.selectedEnterpriseSitesList = sites;

				if(this.smartRebatesGroup) {
						this.selectedSiteList = sites;
						this.shipOutToCustomer = this.motiveEnergyData.motiveEnergyCustomer;
						this.shipOutToSite = this.motiveEnergyData.motiveEnergySite;
					}

					if (this.cblGroup) {
						this.selectedSiteList = sites;
						this.shipOutToCustomer = this.cblCustomerData.customer_id;
						this.shipOutToSite = this.cblCustomerData.site_id;
					}
				}
			});
		} else {
			this.sitesService.getIMEnterpriseSitesInfo(this.shipOutToEnterprise).subscribe((res: any) => {
				const sites = res.sites || [];
				if (sites.length) {
					this.selectedCustomerList = _.chain(sites).map(({ customer_id, customer_name }) => ({ id: customer_id, name: customer_name })).uniq((obj) => { return obj.id; }).value();
					this.selectedCustomerList = this.commonService.sortDataAlphabetically(this.selectedCustomerList, 'name');
					this.selectedEnterpriseSitesList = sites;
				}
			});
		}
	}

	getCustomerInfo() {
		this.sitesService.getCustomerSites(this.shipOutToCustomer, { get_customers: true, device_family: this.selectedDeviceFamily }).subscribe((response: any) => {
			this.handleCustomerEnterprises(response.customerInfo[0])
		});
	}

	handleCustomerEnterprises(customer) {
		this.site.customer_enterprises = customer.customer_enterprises || [];
		this.customerEnterprises = Array.isArray(customer.customer_enterprises)
			? this.shipmentEnterprises.filter((item) => customer.customer_enterprises.includes(item.id))
			: [];

		this.shipmentEnterprises = this.shipmentEnterprises.filter((item) => !this.site.customer_enterprises.includes(item.id));
	}

	handlePowerStudyDevicesSite() {
		this.usePowerStudyDevicesSite = true;
		this.selectedSiteList = _.where(this.selectedEnterpriseSitesList, {customer_id: this.shipOutToCustomer});
		const customerStudySite = this.selectedSiteList.find(site => site.name === this.commonService.powerStudiesDevicesSiteName);
		if (customerStudySite) {
			this.selectedSiteList = [{id: customerStudySite.id, name: customerStudySite.name}];
			this.shipOutToSite = customerStudySite.id;
		} else {
			const powerStudySiteId = this.commonService.powerStudyDevicesSiteId;
			this.selectedSiteList = [{ id: powerStudySiteId, name: this.translateService.instant('studies.power_studies_devices') }];
			this.shipOutToSite = powerStudySiteId;
		}
	}

	isAllDevicesPowerStudies() {
		return this.selectedDevices.length && this.selectedDevices.every(device => this.deviceTypeService.isStudyDevice(device));
	}

	handleShippedDevicesSite() {
		this.shipOutToSite = null;
		this.usePowerStudyDevicesSite = false;
		let sites = _.where(this.selectedEnterpriseSitesList, {customer_id: this.shipOutToCustomer}).filter(site => site.name !== this.commonService.powerStudiesDevicesSiteName);

		// If there are iotemeter devices in the bulk, only show sites that contain iotemeter devices
		// Not Needed
		// if (this.hasIotemeterDevices()) {
		// 	sites = sites.filter(site => site.is_contain_iotemeter_devices);
		// }

		this.selectedSiteList = this.commonService.sortDataAlphabetically(sites, 'name');
		if (this.usersService.hasAccessFunction('create_site') && this.currentUser.isSCT && this.selectedDeviceFamily == DevicesFamily.TELEMETRICS)
			this.selectedSiteList.unshift(this.newSite);
	}

	onCustomerChanged() {
		this.usePowerStudyDevicesSite = false;
		this.clearSelections(1);
		this.getCustomerInfo();
		if (this.shipOutToCustomer) {
			if (this.isAllDevicesPowerStudies()) {
				this.handlePowerStudyDevicesSite();
			} else {
				this.handleShippedDevicesSite();
			}
		}
	}

	updateSiteCoords(coords) {
		this.site.latitude = coords.lat;
		this.site.longitude = coords.lng;
		this.site.address = coords.address;
		this.site.country_id = coords.country;
		this.site.state_id = coords.state;
		this.site.city = coords.city;
		this.chRef.detectChanges();
	}

	clearSelections(level) {
		this.selectedSiteList = null;
		this.shipOutToSite = null;
		if(level > 1) {
			this.selectedCustomerList = null;
			this.shipOutToCustomer = null;
		}
		if(level > 2) {
			this.selectedEnterpriseList = null;
			this.shipOutToEnterprise = null;
		}
	}

	selectFiles(events: any) {
		const existsFile = [];
		let files: any = Object.values(events.target.files);
		if (!files.length)
			return;

		const alreadyFilesNames = this.selectedFiles.map((file: any) => file.row.name);
		const duplicateFiles = [];
		for (const file of files) {
			if (alreadyFilesNames.includes(file.name))
				duplicateFiles.push(file.name);
		}

		if (duplicateFiles.length)
			return this.notificationMessage.setMessage('translate|ready_to_ship.files_already_selected', { clearOnXTimeNavigate: 1 });

		files = this.selectedFiles.map((file) => file.row).concat(files.filter((file: any) => !alreadyFilesNames.includes(file.name)));
		files.forEach((row) => {
			let rowData: TableData = {
				row,
				file_name: {value: row.name},
				action: {icon: 'window-close', action: () => {this.removeSelectedFile(row.name)}}
			}
			existsFile.push(rowData);
		});
		this.selectedFiles = existsFile;
	}

	removeSelectedFile(fileName: string) {
		this.selectedFiles = this.selectedFiles.filter((file: any) => file.row.name !== fileName);
	}

	filesValidation() {
		let selectedFilesValidations = {};
		let totalSize = 0;

		if (this.selectedFiles.length > this.maxFilesCount)
			return selectedFilesValidations = { ...selectedFilesValidations, max_count: true };

		for (const file of this.selectedFiles) {
			const fileExtension = file.row.name.split('.').pop();
			if (!this.allowedUploadFilesExt.includes(fileExtension.toLowerCase()))
				selectedFilesValidations = { ...selectedFilesValidations, extension: true };

			totalSize += file.row.size;
		}

		if (totalSize > this.maxSize)
			selectedFilesValidations = { ...selectedFilesValidations, size: true };

		return selectedFilesValidations;
	}

	multiDevicesValidation(devicesCount: number, maxAllowedCount: number, poNumber: string) {

		// Check devices Count
		if (!devicesCount)
			return { err: this.translateService.instant('shipment.invalid_file_length') };

		// Devices in the file should not exceeded the max allowed number of devices
		if (devicesCount > maxAllowedCount)
			return { err: this.translateService.instant('shipment.csv_file_more_50_records') };

		// Check If the PO Number Selected
		if (!this.po_number)
			return { err: this.translateService.instant('orders.select_po_number') };

		// Check selected order availability (account for already-selected devices)
		if (devicesCount + this.selectedDevices.length > this.getOrderAvailableDevices(poNumber, null))
			return { err: this.translateService.instant('shipment.devices_exceeded_po_remaining') };

		return {};
	}

	async prepareMultiDevicesForShipment(event: any) {

		// Get the file and check if the file exists
		const file = event?.target?.files[0];
		if (!file)
			return this.notificationMessage.setMessage('translate|ready_to_ship.no_selected_files', { clearOnXTimeNavigate: 1 });

		const fileExtension = file.name.split('.').pop();
		const allowedFilesExt = ['csv'];
		if (!allowedFilesExt.includes(fileExtension.toLowerCase())) {
			event.target.value = '';
			this.labelImport.nativeElement.innerText = this.translateService.instant('shipment.import_devices_csv');
			return this.notificationMessage.setMessage('translate|shipment.invalid_file_extension', { clearOnXTimeNavigate: 1 });
		}

		this.labelImport.nativeElement.innerText = file.name;

		const fileAsText = (await file.text()).trim();
		let csvData: string[] = fileAsText.split("\n").map((item: string) => item.replace('\r', '').trim()).filter((item: string) => item && item != '');
		csvData = [...new Set(csvData)];

		const validation = this.multiDevicesValidation(csvData.length, this.maxDevicesCountPerFile, this.po_number);
		if (validation?.err) {
			event.target.value = '';
			this.labelImport.nativeElement.innerText = this.translateService.instant('shipment.import_devices_csv');
			return this.notificationMessage.setMessage(validation?.err, { clearOnXTimeNavigate: 1 });
		}

		const deviceIds = [];
		for (const row of csvData) {
			const macSerialObj = this.commonService.adjustMacSearchString(row);
			if (macSerialObj.mac_address)
				deviceIds.push(macSerialObj.mac_address);
			else
				deviceIds.push(macSerialObj);
		}

		this.multiSearchDeviceSubscription = this.deviceManagementService.searchDevices(deviceIds, this.searchBy, false, false, 'shipping-out', true, this.selectedDeviceFamily).subscribe((data: any) => {

			const devicesInfo = data.devices || [];

			// Check if devices not exists in the system
			if (devicesInfo.length != csvData.length) {
				const macAddresses: string[] = [];
				const serialNumbers: string[]= [];
				const mixMacsAndSerials: string[]= [];
				const mixSerialsAndMacs: string[]= [];

				for (const device of devicesInfo) {
					macAddresses.push(device.mac_address);
					serialNumbers.push(device.serial_number);
					mixMacsAndSerials.push(`${device.mac_address}${device.serial_number}`);
					mixSerialsAndMacs.push(`${device.serial_number}${device.mac_address}`);
				}

				const notFoundDevices = csvData.filter((deviceId: string) => {
					return !macAddresses.includes(deviceId) && !serialNumbers.includes(deviceId) && !mixMacsAndSerials.includes(deviceId) && !mixSerialsAndMacs.includes(deviceId);
				});

				if (notFoundDevices.length) {
					this.bulkSearchNotFoundDevices = notFoundDevices;
					event.target.value = '';
					this.labelImport.nativeElement.innerText = this.translateService.instant('shipment.import_devices_csv');
					this.searchResult = [];
					return;
				}
			}

			this.showUploadFileEle = false;
			this.searchResult = devicesInfo;

			this.sites = _.indexBy(data.sites || [], 'id');
			if (this.searchResult.length > 0) {
				for (const device of this.searchResult) {
					// Edge devices stay in results for the required connectivity/config flow.
					if (device.is_sct_inventory)
						this.prepareForShipment(device, this.sites[device.site_id]?.customer_id);
				}
				event.target.value = '';
			}
		});
	}

	getOrderAvailableDevices(poNumber: string, type: string|null = null) {
		const order = this.allPoNumbers[poNumber];
		if (!type) {
			return Object.values(this.typeToRemainingFieldMap).reduce((total: number, field: string) => {
				return total + (order[field] || 0);
			}, 0);
		}

		const field = this.typeToRemainingFieldMap[type];
		return order[field] || 0;
	}

	checkSmartRebatesShippingOption() {
		this.deviceManagementService.checkSmartRebatesShippingOption().subscribe((data: any) => {
			if (data?.err) {
				this.disableSmartRebateOption = true;
				switch(data.err) {
					case 'motive_enterprise_not_exist':
						this.smartRebatesSelectedErr = this.translateService.instant('shipment.motive_enterprise_promt_msg');
						break;
					case 'motive_customer_not_exist':
						this.smartRebatesSelectedErr = this.translateService.instant('shipment.motive_customer_promt_msg');
						break;
					case 'motive_site_not_exist':
						this.smartRebatesSelectedErr = this.translateService.instant('shipment.motive_site_promt_msg')
						break;
				}
			}
		});
	}

	ngOnDestroy() {
		if (this.multiSearchDeviceSubscription)
			this.multiSearchDeviceSubscription.unsubscribe();
	}

	// --- SCT Managed Shipping Out Methods ---

	getAvailableTokens() {
		this.nocConfigService.getAllNocConfigurations().subscribe((res: any) => {
			const configs = res?.res || res || [];
			// Only unused configs (no mac_address assigned)
			const unused = configs.filter(c => !c.mac_address);
			this.availableTokens = {};
			for (const config of unused) {
				this.availableTokens[config.token] = config;
			}
		});
	}

	getAvailableTokensList() {
		this.availableTokensList = Object.values(this.availableTokens).filter((token: any) => {
			// Exclude tokens already used by other selected devices
			const usedByOther = Object.entries(this.usedTokens).some(
				([mac, t]) => t === token['token'] && mac !== this.selectedDeviceMacAddress
			);
			return !usedByOther;
		});
	}

	openDeviceConfig(device: any) {
		this.selectedDeviceMacAddress = device.mac_address;
		this.deviceConfigData = {
			token: device.token || null,
			meter_number: null,
			power_view_sn: '',
			is_feeder_meter: this.defaultFeederMeter,
			is_meter_subtracting: this.defaultAccumulatingSubtracting,
			ct_ratio: null,
			wiring_mode: this.defaultWiringMode,
			empty_nbiot_bands: true,
			nominal_voltage: null,
		};

		if (device.token) {
			this.applyTokenConfig(device.token);
		}

		this.getAvailableTokensList();
		this.deviceConfigModal.show();
	}

	applyTokenConfig(token: string) {
		if (!token || !this.availableTokens[token]) {
			return;
		}
		const tokenInfo = this.availableTokens[token];
		const config = tokenInfo.config || {};
		this.deviceConfigData = {
			...this.deviceConfigData,
			token,
			meter_number: config.meter_number,
			power_view_sn: config.power_view_sn || '',
			is_feeder_meter: config.is_feeder_meter != null ? config.is_feeder_meter : this.defaultFeederMeter,
			is_meter_subtracting: config.is_meter_subtracting != null ? config.is_meter_subtracting : this.defaultAccumulatingSubtracting,
			ct_ratio: config.ct_ratio,
			wiring_mode: config.wiring_mode != null ? config.wiring_mode : this.defaultWiringMode,
			empty_nbiot_bands: config.empty_nbiot_bands != null ? config.empty_nbiot_bands : true,
			nominal_voltage: config.nominal_voltage,
		};
	}

	onTokenChanged(event: any) {
		// ng-select with bindValue emits the full item object on select, null on clear
		const token = event?.token || (typeof event === 'string' ? event : null);
		if (token) {
			this.applyTokenConfig(token);
		} else {
			// Clear config when token is deselected
			this.deviceConfigData = {
				...this.deviceConfigData,
				token: null,
				meter_number: null,
				power_view_sn: '',
				is_feeder_meter: this.defaultFeederMeter,
				is_meter_subtracting: this.defaultAccumulatingSubtracting,
				ct_ratio: null,
				wiring_mode: this.defaultWiringMode,
				empty_nbiot_bands: true,
				nominal_voltage: null,
			};
			delete this.usedTokens[this.selectedDeviceMacAddress];
		}
	}

	isTokenFieldDisabled(): boolean {
		return !!this.deviceConfigData.token;
	}

	getNominalVoltageHint(): string {
		const wm = this.deviceConfigData.wiring_mode != null ? this.deviceConfigData.wiring_mode : this.defaultWiringMode;
		return `${this.translateService.instant('g.value_for')} ${this.wiringModeNominalText[wm] || 'L-N'}`;
	}

	saveDeviceConfig() {
		const data = { ...this.deviceConfigData };

		if (data.token) {
			const tokenInfo = this.availableTokens[data.token];
			if (tokenInfo) {
				data.token_id = tokenInfo.id;
			}
			this.usedTokens[this.selectedDeviceMacAddress] = data.token;
		} else {
			delete this.usedTokens[this.selectedDeviceMacAddress];
		}

		const deviceIndex = this.selectedDevices.findIndex(d => d.mac_address === this.selectedDeviceMacAddress);
		if (deviceIndex >= 0) {
			this.selectedDevices[deviceIndex] = { ...this.selectedDevices[deviceIndex], ...data };
		}

	}

	isDeviceConfigured(device: any): boolean {
		if (!this.isIotemeterEdgeDevice(device))
			return true;

		return this.shippingOutRequiredFields.every(field => field in device && device[field] != null && device[field] !== '');
	}

	checkShippingOutDevicesData(): string[] {
		const missingDataDevices: string[] = [];
		const invalidMeterDevices: string[] = [];
		for (const device of this.selectedDevices) {
			if (!this.isIotemeterEdgeDevice(device)) continue;
			for (const field of this.shippingOutRequiredFields) {
				if (!(field in device) || device[field] == null || device[field] === '') {
					missingDataDevices.push(device.mac_address);
					break;
				}
			}

			if (device.meter_number > this.maxMeterNumber || device.meter_number < 0)
				invalidMeterDevices.push(device.mac_address);
		}

		if (missingDataDevices.length)
			this.notificationMessage.setMessage(
				this.translateService.instant('ready_to_ship.missing_data_status_err') + ' : ' + missingDataDevices.join(', '),
				{ clearOnXTimeNavigate: 1 }
			);
		else if (invalidMeterDevices.length)
			this.notificationMessage.setMessage(
				this.translateService.instant('ready_to_ship.invalid_meter_number_status_err') + ' : ' + invalidMeterDevices.join(', '),
				{ clearOnXTimeNavigate: 1 }
			);

		return [...missingDataDevices, ...invalidMeterDevices];
	}

	isIotemeterDevice(device: any): boolean {
		return this.deviceTypeService.isIotemeterDevice(device);
	}

	getDeviceTypeString(device: any): string {
		if (this.isIotemeterDevice(device)) {
			const imTypeMap = {
				[DeviceFactory.types.ioTEmeterSp1]: DeviceFactory.typesString.ioTEmeterSp1,
				[DeviceFactory.types.ioTEmeterSp3]: DeviceFactory.typesString.ioTEmeterSp3,
				[DeviceFactory.types.ioTEmeter]: DeviceFactory.typesString.ioTEmeter,
				[DeviceFactory.types.ioTEmeterEdge]: DeviceFactory.typesString.ioTEmeterEdge,
			};
			return imTypeMap[device.sct_device_type];
		}
		const deviceConfig = DeviceFactory.createDevice(device.sct_device_type);
		const isStudyDevice = this.deviceTypeService.isStudyDevice(device);
		return deviceConfig.getTypesString({getPowerStudyDevices: true, is_study_device: isStudyDevice});
	}

	hasIotemeterDevices(): boolean {
		return this.selectedDevices.some(d => this.isIotemeterDevice(d));
	}

	hasIotemeterDevicesInResults(): boolean {
		return this.searchResult?.some(d => this.isIotemeterDevice(d)) || false;
	}

	hasIotemeterEdgeDevices(): boolean {
		return this.selectedDevices.some(device => this.isIotemeterEdgeDevice(device));
	}

	hasIotemeterEdgeDevicesInResults(): boolean {
		return this.searchResult?.some(device => this.isIotemeterEdgeDevice(device)) || false;
	}

	isIotemeterEdgeDevice(device: any): boolean {
		return device?.sct_device_type === DeviceFactory.types.ioTEmeterEdge;
	}

	selectedShipmentDeviceFamilyChanged() {
		switch (this.selectedDeviceFamily) {
			case DevicesFamily.TELEMETRICS:
				this.enterpriseGroups = [...this.originalEnterpriseGroups];
				this.selectedGroup = null;
				break;
			case DevicesFamily.IOTEMETER:
				this.enterpriseGroups = ['customer'];
				this.selectedGroup = this.enterpriseGroups[0];
				break;
			default:
				break;
		}

		this.searchResult = null;
		this.searchString = '';
		this.selectedEnterpriseList = null;

		this.getShipmentEnterprises();

		if (this.selectedGroup)
			this.onGroupChanged();
	}

}
